<template>
  <div class="scroll-div summary_page">
     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
      <div class="row summary_reg_title">
      <div class="chart-title" v-if="initialCallsDone">
        <span>Number of registrations over time</span>
      </div>
      </div>
      <div class="range-div col-md-12 col-lg-12 col-sm-12 p-0" v-if="initialCallsDone">
        <div class="col-md-8 col-lg-8 col-sm-10 col-xs-12 p-0" v-if="permissions.indexOf('EDIT_SUMMARY_EXPORT_DATE_RANGE') > -1">
          <span class="mr-lt-15 date_range_element date_range_cls">Date Range</span>
          <date-picker
            class="mr-lt-15 date_range_summary_tab date_range_element"
            id="datepickerFrom"
            :default-value="forecastStartDate ? forecastStartDate:new Date()"
            v-model="forecastStartDate"
            type="date"
            :disabled-date="notBeforeEndDate"
            :editable="false"
            format="DD/MM/YYYY"
            placeholder="DD/MM/YYYY"
            v-on:change="onForecastPeriodChange"
          ></date-picker>

          <!-- <span class="mr-lt-15 date_range_element to_cls">to</span> -->
          <span class="start-to-end">to</span>

          <date-picker
            class="date_range_summary_tab date_range_element"
            id="datepickerTo"
            :default-value="forecastEndDate ? forecastEndDate: new Date()"
            v-model="forecastEndDate"
            type="date"
            :disabled-date="notBeforeStartDate"
            :editable="false"
            format="DD/MM/YYYY"
            placeholder="DD/MM/YYYY"
            v-on:change="onForecastPeriodChange"
          ></date-picker>
        </div>
        <div v-if="permissions.indexOf('EXPORT_SUMMARY') > -1"
          class="col-md-4 col-lg-4 col-sm-2 col-xs-12 xs-pt-10 pl-0"
        >
         <button class="btn emergo-white-button" @click="exportPopup('forecastsvg')" :disabled="!registrationOverTimeData || !registrationOverTimeData.length">
            <img src="/static/images/icons/icon_share.svg" alt="share-icon" class="margin-btn-plus-icon" /> Export
         </button>
        </div>
      </div>
       <div v-if="initialCallsDone" class="col-lg-12 col-xs-12 col-sm-12 col-md-12 horizontal_legend_summary" id="legend2">
        <span class="key_dot key_dot_registration legend_active"></span><span class="legend_name">Registrations</span>
        <span class="key_dot key_dot_actual legend_active"></span><span class="legend_name">Actual</span>
        <span class="key_dot key_dot_forecast legend_active"></span><span class="key_dot key_dot_forecast legend_active"></span><span class="legend_name">Forecast</span>
      </div>
      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0">
        <div id="registrationOverTimeChartDiv" class="registration-Over-Time-Chart"></div>
      </div>
    </div>
    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0" v-if="initialCallsDone">
      <hr />
    </div>
    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0">
    <div class="row summary_reg_title">
      <div class="chart-title col-md-12 upcoming-expirations" v-if="initialCallsDone">
          <span>Upcoming expirations</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0" v-if="initialCallsDone">
       <div class="col-md-8 col-sm-7 col-xs-12 p-0">
        <div class="mr-lt-15 upcom_expiration_input col-lg-2 col-md-3 col-sm-3 col-xs-12">Over the next</div>
        <div class="col-md-4 col-sm-4 col-xs-5 p-0 mr-lt-15 summary-dropdown">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :searchable="true"
               :options="expirationPeriod"
              label="period"
              track-by="months"
              v-model="selectedExpirationPeriod"
              @input="onExpirationPeriodChange"
              placeholder="Select"
            >
            <span slot="noResult">No matching data</span>
            </multiselect>
          </div>
        </div>
        <div v-if="permissions.indexOf('EXPORT_UPCOMING_EXPIRATIONS') > -1"
          class="col-md-4 col-sm-4 col-xs-12 xs-pt-10 pl-0"
        >
          <button :disabled='disableUpcomingExpButton' class="btn emergo-white-button" @click="exportPopup('expirationSVG')">
            <img src="/static/images/icons/icon_share.svg" alt="share-icon" class="margin-btn-plus-icon" /> Export
          </button>
        </div>
       </div>
      </div>
       <div v-if="initialCallsDone" class="col-xs-12 col-sm-12 col-md-12 horizontal_legend_summary" id="legend2">
        <span class="key_dot key_dot_registration legend_active"></span><span class="legend_name">Registrations</span>
      </div>
      <div class="expired-Bar-Chart" id="expirationBarChartDiv"></div>
    </div>
    <loader :loadingStatus="chartLoaderStatus"></loader>
    <registration-details-popup
      :permissions="permissions"
      :dataRow="activeRegistration"
      @hidePopup="hidePopup"
      :archivedFlag="archivedFlag"
      :reportFlag="reportFlag"
    ></registration-details-popup>
    <permission-access-modal></permission-access-modal>
    <export-popup :documentId="documentId" @resetExportPopup="resetExportPopup"></export-popup>
  </div>
</template>

<script>
import * as d3 from 'd3v4';
import DatePicker from 'vue2-datepicker';
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import EventBus from '../../utils/event-bus';
import RegistrationDetailsPopup from '../Registrations/RegistrationDetailsPopup.vue';
import Loader from '../UIComponents/Loader.vue';
import PermissionAccessModal from '../Common/PermissionAccessModal.vue';
import { getUpcomingExpirationData, getForecastData } from '../../apis/reports';
import { getRegistrationDetailsById } from '../../apis/registrations';
import constructRegistrationObject from '../../utils/registrationDetails';
import ExportPopup from '../Common/ExportPopup.vue';

export default {
  components: {
    PermissionAccessModal,
    Loader,
    DatePicker,
    RegistrationDetailsPopup,
    ExportPopup,
  },
  data() {
    return {
      documentId: '',
      permissions: [],
      mode: 'reports',
      editFlag: '',
      initialCallsDone: false,
      reportFlag: true,
      activeRegistration: {},
      archivedFlag: false,
      errors: [],
      registrationdata: [],
      data: [],
      registrationOverTimeData: [],
      forecastStartDate: '',
      forecastEndDate: '',
      expirationPeriod: [
        { period: '3 months', months: 3 },
        { period: '6 months', months: 6 },
        { period: 'year', months: 12 },
        { period: '2 years', months: 24 },
        { period: '3 years', months: 36 },
        { period: '4 years', months: 48 },
        { period: '5 years', months: 60 },
      ],
      selectedExpirationPeriod: { period: 'year', months: 12 },
      forecastSVG: '',
      chartLoaderStatus: false,
      marginTitle: 0,
    };
  },
  props: ['userRoleId'],
  computed: {
    disableUpcomingExpButton() {
      const upComExpirationData = this.data;
      let exportDisable = true;
      for (let i = 0; i < upComExpirationData.length; i += 1) {
        const obj = upComExpirationData[i];
        const list = obj.registrationList;
        if (list.length > 0) {
          exportDisable = false;
          break;
        }
      }
      return exportDisable;
    },
  },
  methods: {
    exportPopup(id) {
      this.documentId = id;
      $('#exportPdfImg').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    resetExportPopup() {
      this.documentId = '';
      $('#exportPdfImg').modal('hide');
    },
    notBeforeEndDate(date) {
      if (this.forecastEndDate) return date > new Date(this.forecastEndDate).setHours(0, 0, 0, 0);
      return '';
    },
    notBeforeStartDate(date) {
      return date < new Date(this.forecastStartDate).setHours(0, 0, 0, 0);
    },
    updateImportProgressStatus() {
      this.importProgressStatus = false;
      this.importPercentage = 0;
    },
    async loadCharts() {
      this.importProgressStatus = true;
      this.data = [];
      const timePeriodObj = {};
      timePeriodObj.timePeriodMonths = this.selectedExpirationPeriod.months;
      const forecastObj = {
        forecastPeriodStartDate: this.forecastStartDate
          ? moment(this.forecastStartDate).format('YYYY-MM-DD')
          : '',
        forecastPeriodEndDate: this.forecastEndDate ? moment(this.forecastEndDate).format('YYYY-MM-DD') : '',
      };
      this.chartLoaderStatus = true;
      axios
        .all([
          getUpcomingExpirationData(timePeriodObj),
          getForecastData(forecastObj),
        ])
        .then(
          axios.spread((upcomingExpirationData, forecastData) => {
            this.chartLoaderStatus = false;
            this.initialCallsDone = true;
            this.data = upcomingExpirationData;
            if (this.data.length > 0) {
              this.drawExpirationBarChart();
            }
            this.registrationOverTimeData = forecastData;
            if (this.registrationOverTimeData && this.registrationOverTimeData.length) this.drawRegistrationOverTimeChart();
          }),
        );
    },
    drawExpirationBarChart() {
      const parentWidth = this.$el.clientWidth;
      const margin = {
        top: 50, right: 180, bottom: 100, left: 40,
      };
      const width = parentWidth / 2;
      const height = 200;

      const legendWidth = 110;
      const legendRectSize = 9;
      const legendSpacing = 3;

      d3.select('#expirationBarChartDiv svg').remove();
      d3.select('.expiration-tooltip').html('');

      const tooltip = d3.select('.expiration-tooltip');
      tooltip.append('div').attr('class', 'header');
      tooltip.append('div').attr('class', 'body').style('overflow-y', 'auto');

      const svg = d3
        .select('#expirationBarChartDiv')
        .append('svg')
        .attr('id', 'expirationSVG')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom);

      const g = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      const x = d3
        .scaleBand()
        .range([0, width])
        .padding(0.4)
        .align(0.2);

      const y = d3.scaleLinear().range([height, 0]);
      const xAxis = d3.axisBottom(x).tickSize(0);

      if (this.selectedExpirationPeriod.months <= 24) {
        xAxis.tickFormat((date, index) => {
          if (d3.timeFormat('%b')(date) === 'Jan' || index === 0) {
            return d3
              .timeFormat('%b %Y')(date)
              .toUpperCase();
          }
          return d3
            .timeFormat('%b')(date)
            .toUpperCase();
        });
        this.data.map((each) => {
          const d = each;
          d.forecastMonth = moment(d.forecastMonth);
          return d.forecastMonth;
        });
      }

      const yAxis = d3
        .axisLeft(y)
        .ticks(5, 's')
        .tickFormat(d3.format('d'));

      x.domain(
        this.data.map((d) => d.forecastMonth),
      );
      const yTop = d3.max(this.data, (d) => d.registrationsExpiringCount);
      const yMax = yTop <= 5 ? 5 : yTop;
      y.domain([0, yMax]).nice();

      g.selectAll('.grid line, .grid path')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const xAxisg = g
        .append('g')
        .attr('class', 'axis xaxis')
        .attr('transform', `translate(0,${height})`)
        .call(xAxis);

      xAxisg
        .selectAll('text')
        .attr('fill', '#2185D0')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('transform', 'rotate(-45deg)')
        .style('text-anchor', 'end')
        .attr('dx', '-0.35em')
        .attr('dy', '0.8em');

      g.append('g')
        .attr('class', 'axis yaxis')
        .call(yAxis)
        .selectAll('text')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('text-anchor', 'end');

      g.selectAll('.yaxis .tick line').attr('x1', width + margin.left);

      g.selectAll('.yaxis .tick text').attr('dx', '-0.15em');

      g.selectAll('.tick text')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('fill', '#2185D0');

      g.selectAll('.axis path, .tick line')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const that = this;

      g.selectAll('bar')
        .data(this.data)
        .enter()
        .append('rect')
        .style('fill', '#013a68')
        .attr('x', (d) => x(d.forecastMonth))
        .attr('width', x.bandwidth())
        .attr('y', (d) => y(d.registrationsExpiringCount))
        .attr('height', (d) => height - y(d.registrationsExpiringCount))
        .on('mousemove', function(d) { //eslint-disable-line
          const barLeft = parseFloat(d3.select(this).attr('x'))
            + parseFloat(svg.node().getBoundingClientRect().left)
            + parseFloat(d3.select(this).attr('width'))
            + 50;
          d3.select('.expiration-tooltip')
            .style('left', `${barLeft}px`)
            .style('top', `${d3.event.pageY - 40}px`);
          d3.select('.expiration-tooltip').style('display', 'block');
          let headerStr = '';
          if (that.selectedExpirationPeriod.months <= 24) {
            headerStr = `<span>${
              d.registrationsExpiringCount
            } registrations will expire in ${
              moment(d.forecastMonth, 'YYYY/MM/DD').format('MMMM-YYYY')
            }</span>`;
          } else {
            headerStr = `<span>${
              d.registrationsExpiringCount
            } registrations will expire in ${
              d.forecastMonth
            }</span>`;
          }
          d3.select('.expiration-tooltip .header').html(headerStr);
          let linkStr = '';
          d.registrationList.forEach((registration) => {
            linkStr
              += `<div><span class="flag-icon flag-icon-squared flag-icon-${
                registration.countryCode.toLowerCase()
              }"></span><a class="list-group-item small" slot="${
                registration.registrationId
              }">${
                registration.productName
              }</a></div>`;
          });
          d3.select('.expiration-tooltip .body').html(linkStr);
        })
        .on('mouseout', () => {
          setTimeout(() => {
            d3.select('.expiration-tooltip').style('display', 'none');
          }, 700);
        });

      const parentDiv = tooltip.append('div').attr('class', 'tooltipParentDiv');

      parentDiv
        .append('div')
        .attr('class', 'tooltip-header')
        .style('text-anchor', 'middle')
        .attr('font-size', '12px')
        .attr('font-weight', 'bold')
        .attr('fill', 'black');

      const legend = svg
        .append('g')
        .attr('class', 'legend_overtime')
        .attr('font-size', 10)
        .attr('text-anchor', 'start')
        .attr(
          'transform',
          `translate(${
            width + margin.left + margin.right - legendWidth + 10
          },${
            margin.top
          })`,
        )
        .selectAll('g')
        .data(['Registrations'])
        .enter()
        .append('g');

      legend
        .append('rect')
        .attr('width', legendRectSize)
        .attr('height', legendRectSize)
        .attr('fill', '#013a68');

      legend
        .append('text')
        .style('font-size', '14px')
        .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('x', legendRectSize + legendSpacing + 4)
        .attr('y', legendRectSize - legendSpacing + 4)
        .text((d) => d);
    },

    drawRegistrationOverTimeChart() {
      const parentWidth = this.$el.clientWidth;
      const margin = {
        top: 50, right: 180, bottom: 50, left: 40,
      };
      let width = parentWidth / 2;
      const registYearCount = this.registrationOverTimeData.length / 12;
      if (registYearCount > 25) {
        // d3.select('#registrationOverTimeChartDiv').attr('style', `width:${width + margin.left + margin.right}px;`);
        width = (this.registrationOverTimeData.length / 12) * 30;
      }
      const height = 200;
      this.marginTitle = (parentWidth - (width + margin.left + margin.right)) / 2;
      const legendWidth = 110;
      const legendRectSize = 9;
      const legendSpacing = 3;

      d3.select('#registrationOverTimeChartDiv svg').remove();

      this.forecastSVG = d3
        .select('#registrationOverTimeChartDiv')
        .append('svg')
        .attr('id', 'forecastsvg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom);

      const g = this.forecastSVG
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      const x = d3.scaleTime().range([0, width + margin.left]);

      const y = d3.scaleLinear().rangeRound([height, 0]);

      const line = d3
        .line()
        .x((d) => x(moment.utc(d.forecastDate)))
        .y((d) => y(d.registrationCount));

      const certificateLine = d3
        .line()
        .x((d) => x(moment.utc(d.forecastDate)))
        .y((d) => y(d.certificateCount));
      const maxDate = moment.utc(
        this.registrationOverTimeData[this.registrationOverTimeData.length - 1]
          .forecastDate,
      );
      const minDate = moment.utc(this.registrationOverTimeData[0].forecastDate);
      x.domain([minDate, maxDate]);
      const yTop = d3.max(this.registrationOverTimeData, (d) => d.registrationCount);
      const yMax = yTop < 5 ? 5 : yTop;
      y.domain([0, yMax]).nice();

      const theDate = new Date(new Date().setHours(0, 0, 0, 0));
      const currentDate = moment().format('YYYY-MM-DD');
      const maxDateComparision = moment(
        this.registrationOverTimeData[this.registrationOverTimeData.length - 1]
          .forecastDate,
      );
      const minDateComparision = moment(
        this.registrationOverTimeData[0].forecastDate,
      );
      const xAxisg = g
        .append('g')
        .attr('class', 'xaxis axis')
        .attr('transform', `translate(0,${height})`)
        .call(
          d3
            .axisBottom(x)
            .ticks(d3.timeYear.every(1))
            .tickSize(0)
            .tickSizeInner(-height),
        );
      xAxisg
        .append('text')
        .text(`${minDate.year()}`)
        .attr('class', 'firstX');

      xAxisg
        .selectAll('text')
        .attr('fill', '#2185D0')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('text-anchor', 'start')
        .attr('dx', '-1.25em')
        .attr('dy', '2em');
      d3.selectAll('.firstX').attr('dy', '2.25em');
      if (
        minDateComparision.format('YYYY-MM-DD') <= currentDate
        && maxDateComparision.format('YYYY-MM-DD') >= currentDate
      ) {
        xAxisg
          .append('text')
          .text('Today')
          .attr('x', x(theDate))
          .attr('fill', '#ff7d2c')
          .style('font-size', '11px')
          .style('font-weight', '600')
          .attr('dx', '.20em')
          .attr('dy', '1.3em');

        // Vertical line for today
        g.append('svg:line')
          .attr('class', 'today')
          .attr('x1', x(theDate))
          .attr('y1', height)
          .attr('x2', x(theDate))
          .attr('y2', 0)
          .attr('fill', '#ff7d2c')
          .attr('stroke', '#ff7d2c')
          .attr('stroke-width', 1);
      }

      xAxisg
        .selectAll('.axis path, .axis line')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      g.append('g')
        .attr('class', 'yaxis axis')
        .call(
          d3
            .axisLeft(y)
            .ticks(5, 's')
            .tickSize(0)
            .tickFormat(d3.format('d')),
        )
        .selectAll('text')
        .style('font-family', 'roboto')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('text-anchor', 'end');

      g.selectAll('.yaxis .tick text').attr('dx', '-0.15em');

      g.selectAll('.axis path, .axis line')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const focus = g
        .append('g')
        .attr('class', 'focus')
        .style('display', 'none');

      focus.append('circle').attr('r', 2);

      focus
        .append('text')
        .attr('x', -10)
        .attr('dy', '-1em');

      const p = g
        .append('path')
        .datum(this.registrationOverTimeData)
        .attr('fill', 'none')
        .attr('stroke', '#013a68')
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 2)
        .attr('d', line)
        .on('mouseover', () => {
          focus.style('display', null);
        })
        .on('mouseout', () => {
          focus.style('display', 'none');
        })
        .on('mousemove', function(d) { //eslint-disable-line
          const x0 = x.invert(d3.mouse(this)[0]);
          const a = new Date(x0);
          const curDate = new Date(a.getFullYear(), a.getMonth(), 1);
          let curData;
          d.forEach((curD) => {
            if (curD.forecastDate === moment(curDate).format('YYYY/MM/DD')) {
              curData = curD;
            }
          });
          focus.attr(
            'transform',
            `translate(${x(curDate)},${y(curData.registrationCount)})`,
          );
          focus.select('text').text(() => curData.registrationCount);
          focus
            .select('.x-hover-line')
            .attr('y2', height - y(d.registrationCount));
          focus.select('.y-hover-line').attr('x2', width + width);
        });

      const p2 = g
        .append('path')
        .datum(this.registrationOverTimeData)
        .attr('fill', 'none')
        .attr('stroke', '#2185D0')
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 2)
        .attr('d', certificateLine)
        .on('mouseover', () => {
          focus.style('display', null);
        })
        .on('mouseout', () => {
          focus.style('display', 'none');
        })
        .on('mousemove',function(d) { //eslint-disable-line
          const x0 = x.invert(d3.mouse(this)[0]);
          const a = new Date(x0);
          const curDate = new Date(a.getFullYear(), a.getMonth(), 1);
          let curData;
          d.forEach((curD) => {
            if (curD.forecastDate === moment(curDate).format('YYYY/MM/DD')) {
              curData = curD;
            }
          });
          focus.attr(
            'transform',
            `translate(${x(curDate)},${y(curData.certificateCount)})`,
          );
          focus.select('text').text(() => curData.certificateCount);
          focus
            .select('.x-hover-line')
            .attr('y2', height - y(d.certificateCount));
          focus.select('.y-hover-line').attr('x2', width + width);
        });
      function getStrokeArray(pStorke) {
        // draw dashed from 2.7 to 7 in the X domain
        const dashBetweenX = [theDate, maxDate];
        const path = pStorke.node();
        const totalLen = path.getTotalLength();

        // find the corresponding line lengths
        const dashBetweenL = dashBetweenX.map((d) => {
          let beginning = 0;
          let end = totalLen;
          let target = null;
          const d1 = x(d);

          // find the line lengths the correspond to our X values
          // stolen from @duopixel from http://bl.ocks.org/duopixel/3824661
          while (true) { // eslint-disable-line no-constant-condition
            target = Math.floor((beginning + end) / 2);
            const pos = path.getPointAtLength(target);
            if ((target === end || target === beginning) && pos.x !== d1) {
              break;
            }
            if (pos.x > d1) end = target;
            else if (pos.x < d1) beginning = target;
            else break; // position found
          }

          return target;
        });
        // draw the dashes
        let sd = dashBetweenL[0];
        let dp = dashBetweenL[0];
        let count = 0;
        while (dp < dashBetweenL[1]) {
          dp += 5;
          sd += ', 5';
          count += 1;
        }
        // per answer below needs odd number of dash array
        if (count % 2 === 0) sd += ', 5';
        sd += `, ${totalLen - dashBetweenL[1]}`;
        return sd;
      }

      p.attr('stroke-dasharray', getStrokeArray(p));
      p2.attr('stroke-dasharray', getStrokeArray(p2));

      const legend = this.forecastSVG
        .append('g')
        .attr('class', 'legend_forecast')
        .attr('font-size', 10)
        .attr('text-anchor', 'start')
        .attr(
          'transform',
          `translate(${
            width + margin.left + margin.right - legendWidth + 4
          },${
            margin.top
          })`,
        )
        .selectAll('g')
        .data(['Registrations', 'Actual', 'Forecast'])
        .enter()
        .append('g')
        .attr('transform', (d, i) => `translate(0,${i * 20})`);

      legend
        .append('rect')
        .attr('width', (d) => {
          if (d === 'Registrations') {
            return legendRectSize;
          }
          return legendRectSize * 1.6;
        })
        .attr('height', (d) => {
          if (d === 'Registrations') {
            return legendRectSize;
          }
          return 0.1;
        })
        .attr('x', (d) => {
          if (d === 'Registrations') {
            return (legendRectSize * 1.5 - legendRectSize) / 2;
          }
          return 0;
        })
        .attr('y', (d) => {
          if (d === 'Registrations') {
            return 0;
          }
          return legendRectSize / 2;
        })
        .attr('fill', (d) => {
          if (d === 'Forecast') {
            return '#fff';
          }
          return '#013a68';
        })
        .attr('stroke', '#013a68')
        .attr('stroke-width', (d) => {
          if (d === 'Registrations') {
            return 0;
          }
          return 2;
        })
        .attr('stroke-dasharray', (d) => {
          if (d === 'Forecast') {
            return '4, 4';
          }
          return '0, 0';
        });

      legend
        .append('text')
        .style('font-size', '14px')
        .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('x', legendRectSize + legendSpacing + 10)
        .attr('y', legendRectSize - legendSpacing + 4)
        .text((d) => d);
    },
    async onExpirationPeriodChange(selectedExpirationPeriod) {
      this.selectedExpirationPeriod = selectedExpirationPeriod;
      this.chartLoaderStatus = true;
      const timePeriodObj = {};
      timePeriodObj.timePeriodMonths = this.selectedExpirationPeriod.months;
      this.data = await getUpcomingExpirationData(timePeriodObj);
      this.chartLoaderStatus = false;
      if (this.data.length > 0) {
        this.drawExpirationBarChart();
      }
    },
    async onForecastPeriodChange() {
      this.chartLoaderStatus = true;
      const forecastObj = {
        forecastPeriodStartDate: this.forecastStartDate
          ? moment(this.forecastStartDate).format('YYYY-MM-DD')
          : '',
        forecastPeriodEndDate: this.forecastEndDate ? moment(this.forecastEndDate).format('YYYY-MM-DD') : '',
      };
      const regForecast = await getForecastData(forecastObj);
      this.registrationOverTimeData = regForecast;
      this.chartLoaderStatus = false;
      if (this.registrationOverTimeData && this.registrationOverTimeData.length) this.drawRegistrationOverTimeChart();
    },

    viewRegistration(record) {
      this.activeRegistration = record;
      this.activeId = record.registrationId;
      $('#registrationDetail').modal();
    },

    async callRegistration(value) {
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        if (this.userRoleId === 4) {
          return;
        }
        this.chartLoaderStatus = true;
        const row = await getRegistrationDetailsById(value);
        this.chartLoaderStatus = false;
        if (!row || (row && row.error)) {
          this.$notify({
            clear: true,
            group: 'custom-notification',
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification',
          });
        } else {
          const entry = constructRegistrationObject(row);
          this.viewRegistration(entry);
        }
      }
    },
    closeModal(e) {
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      this.activeId = '';
    },
    hidePopup(value) {
      this.editFlag = value;
    },
  },

  mounted() {
    d3.select('.scroll-div')
      .append('div')
      .attr('class', 'expiration-tooltip')
      .style('display', 'none');
    $('.expiration-tooltip').on('click', '.small', (event) => {
      this.callRegistration(event.target.getAttribute('slot'));
    });

    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
    EventBus.$on('permissionsSummaryList', (permissionsList) => {
      this.permissions = permissionsList;
    });
  },
  async created() {
    const startDate = new Date();
    startDate.setFullYear(new Date().getFullYear() - 2);
    startDate.setMonth(0);
    startDate.setDate(1);
    this.forecastStartDate = startDate;

    const endDate = new Date();
    endDate.setFullYear(new Date().getFullYear() + 2);
    endDate.setMonth(0);
    endDate.setDate(1);
    this.forecastEndDate = endDate;
    await this.loadCharts();
    let socket1 = 0;
    let socket2 = 0;
    socket.on(
      `alertGetForecastData_${localStorage.getItem('userId')}`,
      (data) => {
        socket1 = Math.ceil(data / 2);
        this.importPercentage = socket1 + socket2;
      },
    );

    socket.on(
      `alertGetUpcomingExpirationData_${localStorage.getItem('userId')}`,
      (data) => {
        socket2 = Math.ceil(data / 2);
        this.importPercentage = socket1 + socket2;
      },
    );
    if (this.$route.params.reportPermissions) {
      this.permissions = this.$route.params.reportPermissions;
    }
  },
  beforeDestroy() {
    socket.removeAllListeners(
      `alertGetForecastData_${localStorage.getItem('userId')}`,
    );
    socket.removeAllListeners(
      `alertGetUpcomingExpirationData_${localStorage.getItem('userId')}`,
    );
    $('.expiration-tooltip').remove();
    EventBus.$off('permissionsSummaryList');
  },
};
</script>
<style scoped>
#registrationOverTimeChartDiv, #expirationBarChartDiv {
  overflow-x: auto;
  overflow-y: hidden;
}
.p-0{
 padding:0;
}
.upcom_expiration_input {
  padding-right: 0px;
  padding-left: 0px;
  padding-top:4px;
}

.ui.fluid.dropdown {
  margin-left: 5px;
  min-height: 0em;
  height: 35px;
  padding-top:7px;
}
.ui.fluid.dropdown > .dropdown.icon{
  padding-top: 8px;
}

.range-div .mx-datepicker {
  width: 144px;
}
::v-deep .range-div .mx-datepicker .mx-input {
  padding: 8px 16px 8px 35px;
  font-size: 14px;
  color: #000000;
  border: 0.5px solid #000000;
  border-radius: 3px;
  font-weight: 300;
}
::v-deep .range-div .mx-datepicker .mx-input-wrapper .mx-icon-calendar {
  left: 12px;
}
::v-deep .range-div .mx-datepicker .mx-input-wrapper .mx-icon-clear {
  right: 116px;
}
.start-to-end {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  padding: 5px 8px;
  display: inline;
}
.upcoming_expiration_export{
 padding: 0px;
}
.summary_reg_title{
  margin: 0px;
}
.summary_page .key_dot{
  border-radius: 0px;
}
.key_dot_registration{
  width: 9px;
  height: 9px;
}
.key_dot_actual{
  height: 2px;
  width: 17px;
  vertical-align: middle;
}
.key_dot_forecast{
  height: 2px;
  width: 5px;
  vertical-align: middle;
  margin-right: 0.15em;
}
.legend_name{
  color: #4f90c3;
  font-weight: 500;
}
@media (min-width: 320px) and (max-width: 767px) {
   .ui.fluid.dropdown {
    margin-left: 0px;
  }
}
@media screen and (max-width: 767px) {
  .xs-pt-10 {
      padding-top: 10px;
  }
}
@media (max-width: 972px) {
  .range-div {
    display: inline-block;
  }
  .mr-lt-15{
    margin-left: 0;
  }
}
</style>
